<ngx-spinner
  [fullScreen]="true"
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-clip-rotate-multiple"
></ngx-spinner>
<div class="teranet-center">
  <mat-card>
    <div class="form-group">
      <div *ngIf="isLoginError || isAccountLocked" class="alert alert-danger" role="alert">
        {{ errorMessage }}
      </div>
    </div>
    <mat-card-content>
      <form [formGroup]="reactiveForm">
        <div fxLayout.xs="column" fxLayout="row wrap">
          <div fxFlex="75" tabindex="0">
            <h4 i18n="@@login_title">Sign in to your account</h4>
          </div>
          <div fxFlex="25">
            <label id="lblRequiredField">
              <span id="spnRequired" class="required-field" i18n="@@login_span_required"
                >Required Field</span
              >
            </label>
          </div>
        </div>
        <div fxLayout.xs="column" fxLayout="row wrap">
          <div class="form-group-flex-column">
            <mat-label
              id="lblUserName"
              class="required-field-after"
              for="txtUserName"
              i18n="@@login_lbl_username"
              >User Name</mat-label
            >
            <mat-form-field class="mat-form-field-md" appearance="outline">
              <mat-icon matPrefix>person</mat-icon>
              <input
                matInput
                id="txtUserName"
                #userName
                type="text"
                data-lpignore="true"
                formControlName="email"
                required
                autocomplete="username"
              />
              <mat-error
                *ngIf="
                  !isLoginError ||
                  (!reactiveForm.controls['email'].valid &&
                    reactiveForm.controls['email'].dirty &&
                    reactiveForm.controls['email'].errors['required'])
                "
              >
                Please fill out this field.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-group-flex-column">
            <mat-label
              id="lblPassword"
              class="required-field-after"
              for="txtPassword"
              i18n="@@login_lbl_password"
              >Password</mat-label
            >
            <mat-form-field class="mat-form-field-md" appearance="outline">
              <mat-icon matPrefix>vpn_key</mat-icon>
              <input
                matInput
                id="txtPassword"
                #password
                type="password"
                data-lpignore="true"
                formControlName="password"
                (change)="valueChange($event)"
                required
                autocomplete="current-password"
              />
              <mat-error
                *ngIf="
                  !isLoginError ||
                  (!reactiveForm.controls['password'].valid &&
                    reactiveForm.controls['password'].dirty &&
                    reactiveForm.controls['password'].errors['required'])
                "
              >
                Please fill out this field.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
    </mat-card-content>
    <mat-card-actions>
      <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="100">
        <div class="icon-button">
          <button
            mat-button
            (click)="login()"
            [disabled]="(!userNameAutofilled || !passwordAutofilled) && reactiveForm.invalid"
            i18n="@@login_btn_signin"
          >
            <div class="btnicon">
              <fa-icon icon="lock" class="fa-lg" matTooltipPosition="above"></fa-icon>
            </div>
            <div class="btntext">Sign In</div>
          </button>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutAlign="end center" fxFlex="100">
        <a [routerLink]="'/forgetpassword'">Forgot your password?</a>
      </div>
    </mat-card-actions>
  </mat-card>
</div>
